// IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: подсветка изменений записи из аудита)
// Форма «Audit restore [aid]» (widget-record из аудита): разница открытой версии записи против СЛЕДУЮЩЕЙ (по умолчанию — слово Игоря
// 27.10 «по умолчанию было со следующей»: то, что изменило само событие этой строки аудита, как колонка Changes) или ПРЕДЫДУЩЕЙ версии
// журнала. Данные — WIDGET.audit_diff от бэка (BE audit_changes.version_diff, ветка ie-webscm7-audit-record-diff):
//   { audit_id, collection, direction: 'next' (сторона по умолчанию), view: 'badges' | 'diff' | 'full' (настройка audit.record_diff_view),
//     status, n (копия стороны по умолчанию), next: <сторона>, prev: <сторона> }
//   <сторона> = { direction, status: 'ok' | 'live' (следующая версия — живая запись) | 'first' | 'deleted' | 'prev_unavailable' | 'next_unavailable' |
//     'this_unavailable' | 'too_large' | 'no_function' | 'error', reason (текст на языке пользователя), other_audit_id, other_live, changed_at,
//     changed_by, opened_side: 'new' | 'old', n, text, truncated, open_action (необязательно — «Open … version»),
//     fields: { '<binding>': { old, new } },                                        // binding = attr.binding поля формы ('doc.Поставщик')
//     tables: { '<binding ТЧ>': { rows: { '<i>': { '<колонка>' | '*': { old, new } | { nested, paths } } },
//               added: [i] — строки только в ОТКРЫТОЙ версии, removed: [{ index, row }] — строки только в ДРУГОЙ версии (index — в ней),
//               resized: { old, new } | null — длины без ключа строк, сопоставить нельзя } } }
// Сторона, не посчитанная при открытии (бюджет BE 2,5 с), приходит со status 'deferred': по выбору стороны / кнопке «Calculate» фронт
// зовёт executeBackendMethod 'audit_record_diff' params { audit_id, collection, direction } — ответ = одна сторона; пока идёт расчёт — 'calculating'.
// Индекс строки ТЧ (rows, added) — позиция строки в массиве ОТКРЫТОЙ версии записи. «old» / «new» — по времени: против предыдущей открытая
// версия = new, против следующей — old. Все функции чистые: строки записи не меняются (ни _DLRow, ни
// служебных ключей — иначе они уехали бы в Restore), скрытие строк — набором объектов на стороне грида.
import { t, tn } from '@/i18n'
import { durUnit } from '@/utils/durationText'

export const ADF_FLAG = 'fe.ux.auditRecordDiff'
export const ADF_VIEW_KEY = 'fe.ux.auditRecordDiff.view'
export const ADF_VIEWS = ['badges', 'diff', 'full']
export const ADF_MAX_LIST = 200   // записей в списке «Full comparison» поповера

const isObj = (v) => !!v && typeof v === 'object' && !Array.isArray(v)

// выключатель fe.ux.auditRecordDiff (по умолчанию вкл); setting — store.setting или его обёртка
export function adf_on(setting) {
    try { return typeof setting === 'function' ? setting(ADF_FLAG, true) !== false : true } catch (e) { return true }
}

// IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: подсветка изменений записи из аудита): дефект D1 пробы dev02 — бейдж «⇄ N» не появлялся при открытии формы. Ответ widget_open кладётся
// Object.assign(WIDGET, answer.WIDGET) в СЫРОЙ объект виджета (mainStore), мимо реактивного прокси: computed adf_diff формы (Widget.vue)
// успевает вычислиться на скелете (audit_diff ещё нет) и остаётся в кэше. После такой записи — пинок форме: Widget.vue доступен как
// WIDGET.attrs_vueObj.WIDGET (created), его auditDiff_sync сверяет audit_diff с увиденным и, если сменился, пересчитывает разницу.
export function adf_kick(WIDGET) {
    const vm = WIDGET?.attrs_vueObj?.WIDGET
    if (!vm || typeof vm.auditDiff_sync !== 'function') return false
    try { vm.auditDiff_sync() } catch (e) { console.warn('auditDiff_sync', e); return false }
    return true
}

export function adf_viewOf(diff, stored) {
    if (ADF_VIEWS.includes(diff?.view_user)) return diff.view_user
    if (ADF_VIEWS.includes(stored)) return stored
    return ADF_VIEWS.includes(diff?.view) ? diff.view : 'badges'
}

// сторона сравнения: выбор пользователя (against_user) → сторона бэка по умолчанию (direction) → СЛЕДУЮЩАЯ версия (слово Игоря 27.10)
export function adf_againstOf(diff) {
    if (diff?.against_user === 'prev' || diff?.against_user === 'next') return diff.against_user
    if (diff?.direction === 'prev' || diff?.direction === 'next') return diff.direction
    return 'next'
}
export const ADF_CALC_METHOD = 'audit_record_diff'
export const adf_isDeferred = (block) => block?.status === 'deferred'
// параметры запроса досчёта стороны
export function adf_calcParams(diff, direction) {
    return { audit_id: diff?.audit_id, collection: diff?.collection, direction: direction === 'prev' ? 'prev' : 'next' }
}
// сторона из ответа executeBackendMethod (BE: { audit_record_diff: <сторона>, audit_id, direction, seconds }; допускается голая сторона и
// поля audit_diff_side / side / result); ответ на другую версию / сторону (форма уже показывает другую запись) — null
export function adf_sideFromAnswer(answer, direction, auditId) {
    if (!isObj(answer)) return null
    if (auditId != null && answer.audit_id != null && String(answer.audit_id) !== String(auditId)) return null
    if (direction && answer.direction && answer.direction !== direction && !isObj(answer.audit_record_diff)) return null
    if (direction && isObj(answer.audit_record_diff) && answer.direction && answer.direction !== direction) return null
    const cands = [answer.audit_record_diff, answer.audit_diff_side, answer.side, answer.result, answer[direction], answer]
    for (const c of cands) {
        if (!isObj(c) || typeof c.status !== 'string' || c.status === '') continue
        if (c === answer && !('fields' in c || 'tables' in c || 'direction' in c || 'opened_side' in c)) continue   // голый статус ядра ({status:'error'}) — не сторона
        if (c.direction && direction && c.direction !== direction) continue
        return c
    }
    return null
}
// сторона со строками разметки: 'live' — та же разница, только другая версия — живая запись
export const adf_isOk = (block) => block?.status === 'ok' || block?.status === 'live'

// блок сравнения выбранной стороны: audit_diff.<side>, иначе верхний уровень, если он своей side (diff.side, нет — 'prev')
export function adf_block(diff, against) {
    if (!isObj(diff)) return null
    const side = against === 'prev' ? 'prev' : 'next'
    if (isObj(diff[side])) return diff[side]
    const top = (diff.side || diff.direction) === 'next' ? 'next' : 'prev'
    if (top === side && diff.status && (isObj(diff.fields) || isObj(diff.tables) || !adf_isOk(diff))) return diff
    return { status: 'unavailable', reason: '' }
}

const rowKeys = (tb) => Object.keys(isObj(tb?.rows) ? tb.rows : {}).filter(k => /^\d+$/.test(k)).map(Number).sort((a, b) => a - b)
const idxList = (v) => (Array.isArray(v) ? v : []).map(x => (isObj(x) ? Number(x.index) : Number(x))).filter(Number.isInteger)
// длины ТЧ без ключа строк: бэк — { old, new } (по времени), допускается и [a, b]
const resizedOf = (tb) => {
    const r = tb?.resized
    if (r === null || r === undefined || r === false) return null
    if (Array.isArray(r)) return r
    if (isObj(r)) return [r.old, r.new]
    return [null, null]
}
export const adf_tableTitle = (binding) => String(binding || '').replace(/^_?doc\./, '')

// индекс разницы для отрисовки: поле формы, ячейка / состояние строки ТЧ, число изменений, цели навигации, список «Full comparison»
export function adf_index(block, against = 'next') {
    const ok = adf_isOk(block)
    const fields = ok && isObj(block.fields) ? block.fields : {}
    const tables = ok && isObj(block.tables) ? block.tables : {}
    const next = against === 'next'
    // поле-объект, показанное одной строкой ('doc.a'), изменилось, если изменилось его вложенное поле ('doc.a.b')
    const prefixes = new Set()
    for (const k of Object.keys(fields)) { const p = k.split('.'); for (let i = 1; i < p.length; i++) prefixes.add(p.slice(0, i).join('.')) }

    const field = (binding) => {
        if (!binding) return null
        const b = String(binding)
        if (isObj(fields[b])) return fields[b]
        if (tables[b]) return { table: true, nested: true }
        if (prefixes.has(b)) return { nested: true }
        return null
    }
    const table = (tbl) => (isObj(tables[tbl]) ? tables[tbl] : null)
    const rowState = (tbl, i) => {
        const tb = table(tbl)
        if (!tb || !Number.isInteger(i) || i < 0) return ''
        if (resizedOf(tb)) return 'resized'
        // строка только в открытой версии: против предыдущей — добавлена, против следующей — её там уже нет
        if (idxList(tb.added).includes(i)) return next ? 'removed' : 'added'
        return isObj(tb.rows?.[String(i)]) ? 'changed' : ''
    }
    const cell = (tbl, i, col) => {
        const r = table(tbl)?.rows?.[String(i)]
        if (!isObj(r) || !col) return null
        const c = String(col)
        if (isObj(r[c])) return r[c]
        const base = c.split('.')[0]
        if (isObj(r[base])) return r[base]
        // вложенное поле ячейки ('Номенклатура.title' в колонке 'Номенклатура')
        if (Object.keys(r).some(k => k.startsWith(c + '.'))) return { nested: true }
        if (isObj(r['*'])) return { nested: true }   // строка изменилась целиком (не объект) — помечаются все её ячейки
        return null
    }
    const isResized = (tbl) => resizedOf(table(tbl))
    // IE 2026 10 31 / ODOO-349799 (заказ Игоря: переход ‹ › по изменениям): в колонке ТЧ есть изменённая ячейка (любая строка) — режим «Hide empty
    // rows, columns, tabs» такую колонку не прячет; колонка узнаётся как в cell(): точное имя, корень пути ('Номенклатура.title'), строка целиком ('*')
    const colChanged = (tbl, col) => {
        const tb = table(tbl)
        if (!tb || !col || !isObj(tb.rows)) return false
        const c = String(col), base = c.split('.')[0]
        for (const r of Object.values(tb.rows)) {
            if (!isObj(r)) continue
            if (isObj(r[c]) || isObj(r[base]) || isObj(r['*'])) return true
            if (Object.keys(r).some(k => k.startsWith(c + '.'))) return true
        }
        return false
    }

    let count = 0
    for (const k of Object.keys(fields)) if (isObj(fields[k])) count++
    for (const tb of Object.values(tables)) {
        if (!isObj(tb)) continue
        if (resizedOf(tb)) { count++; continue }
        for (const i of rowKeys(tb)) count += Object.keys(tb.rows[String(i)] || {}).length
        count += idxList(tb.added).length + idxList(tb.removed).length
    }
    const n = ok ? (Number.isFinite(Number(block.n)) && block.n !== null && block.n !== '' ? Number(block.n) : count) : 0

    // цели навигации ‹ › — поля, затем таблицы по строкам (только то, что есть в ОТКРЫТОЙ версии)
    const targets = () => {
        const out = []
        for (const b of Object.keys(fields)) if (isObj(fields[b])) out.push({ kind: 'field', binding: b })
        for (const tbl of Object.keys(tables)) {
            const tb = tables[tbl]
            if (!isObj(tb)) continue
            if (resizedOf(tb)) { out.push({ kind: 'table', table: tbl }); continue }
            const marked = idxList(tb.added)
            const all = [...new Set([...rowKeys(tb), ...marked])].sort((a, b) => a - b)
            for (const i of all) {
                const cols = Object.keys(tb.rows?.[String(i)] || {})
                if (cols.length) for (const col of cols) out.push({ kind: 'cell', table: tbl, row: i, col })
                else out.push({ kind: 'row', table: tbl, row: i })
            }
        }
        return out
    }

    // список изменений «Full comparison»: подпись, значение другой версии, значение открытой
    const entries = (limit = ADF_MAX_LIST) => {
        const out = []
        const push = (e) => { if (out.length < limit) out.push(e) }
        for (const b of Object.keys(fields)) {
            const d = fields[b]
            if (!isObj(d)) continue
            push({ label: adf_tableTitle(b), other: adf_valueText(adf_other(d, against)), cur: adf_valueText(adf_cur(d, against)), target: { kind: 'field', binding: b } })
        }
        for (const tbl of Object.keys(tables)) {
            const tb = tables[tbl]
            if (!isObj(tb)) continue
            const tt = adf_tableTitle(tbl)
            const rz = resizedOf(tb)
            if (rz) { push({ label: tt, other: '', cur: adf_resizedText(rz), target: { kind: 'table', table: tbl } }); continue }
            for (const i of rowKeys(tb)) {
                for (const [col, d] of Object.entries(tb.rows[String(i)] || {})) {
                    push({ label: col === '*' ? t('{table} · row {row}', { table: tt, row: i + 1 }) : t('{table} · row {row} · {field}', { table: tt, row: i + 1, field: col }), other: adf_valueText(adf_other(d, against)), cur: adf_valueText(adf_cur(d, against)), target: { kind: 'cell', table: tbl, row: i, col } })
                }
            }
            // строки только в открытой версии (индекс — в ней): против предыдущей добавлены, против следующей удалены дальше
            for (const i of idxList(tb.added)) {
                push({ label: t('{table} · row {row}', { table: tt, row: i + 1 }), other: next ? t('removed') : '—', cur: next ? t('present') : t('added'), target: { kind: 'row', table: tbl, row: i } })
            }
            // строки только в другой версии (индекс — в ней): против предыдущей удалены этой версией, против следующей добавлены
            for (const x of (Array.isArray(tb.removed) ? tb.removed : [])) {
                const i = isObj(x) ? Number(x.index) : Number(x)
                if (!Number.isInteger(i)) continue
                push({ label: t('{table} · row {row}', { table: tt, row: i + 1 }), other: (next ? t('added') + ': ' : '') + adf_rowText(x?.row), cur: next ? '—' : t('removed'), target: null })
            }
        }
        return out
    }

    return { ok, status: block?.status || '', n, against, field, table, rowState, cell, isResized, colChanged, targets, entries, tables: Object.keys(tables) }
}

// значение другой версии (тултип) и открытой
export function adf_other(d, against) { return against === 'next' ? d?.new : d?.old }
export function adf_cur(d, against) { return against === 'next' ? d?.old : d?.new }

export function adf_valueText(v) {
    if (v === null || v === undefined || v === '') return '—'
    if (typeof v === 'boolean') return v ? '✓' : '✗'
    if (Array.isArray(v)) return tn(v.length, '{n} item', '{n} items')
    if (isObj(v)) {
        const s = v.title ?? v.name ?? v.id
        if (s !== undefined && s !== null && s !== '') return String(s)
        let j = ''
        try { j = JSON.stringify(v) } catch (e) { j = String(v) }
        return j.length > 80 ? j.slice(0, 79) + '…' : j
    }
    const s = String(v).replace(/^(\d{4}-\d{2}-\d{2})T00:00:00(?:\.0+)?(?:Z|[+-]00:?00)?$/, '$1')   // дата 1С без времени — только дата
    return s.length > 120 ? s.slice(0, 119) + '…' : s
}

// строка ТЧ одной строкой для списка (первые непустые значения)
export function adf_rowText(row) {
    if (!isObj(row)) return '—'
    const parts = []
    for (const v of Object.values(row)) {
        if (v === null || v === undefined || v === '' || typeof v === 'boolean') continue
        parts.push(adf_valueText(v))
        if (parts.length >= 3) break
    }
    return parts.join(' · ') || '—'
}

const NUM_RE = /^\s*-?\d+(?:[.,]\d+)?\s*$/
const DATE_RE = /^(\d{4})-(\d{2})-(\d{2})(?:$|[T ])/
const toNum = (v) => (typeof v === 'number' && Number.isFinite(v)) ? v : (typeof v === 'string' && NUM_RE.test(v) ? Number(v.replace(',', '.')) : null)
const toDay = (v) => { const m = typeof v === 'string' ? DATE_RE.exec(v) : null; return m ? Date.UTC(+m[1], +m[2] - 1, +m[3]) / 86400000 : null }

function shortNum(abs) {
    if (abs >= 1e9) return (abs / 1e9).toFixed(1) + 'B'
    if (abs >= 1e6) return (abs / 1e6).toFixed(1) + 'M'
    if (abs >= 1e4) return Math.round(abs / 1e3) + 'K'
    if (abs >= 1e3) return (abs / 1e3).toFixed(1) + 'K'
    return String(Math.round(abs * 100) / 100)
}

// текст пилюли бейджа: изменение от более ранней версии к более поздней — ±Δ у чисел, ±дни у дат, иначе «≠»
export function adf_badgeText(d) {
    if (!isObj(d) || d.nested) return '≠'
    const a = toNum(d.old), b = toNum(d.new)
    if (a !== null && b !== null) {
        const delta = b - a
        if (!delta) return '≠'
        return (delta > 0 ? '+' : '−') + shortNum(Math.abs(delta))
    }
    const da = toDay(d.old), db = toDay(d.new)
    if (da !== null && db !== null && da !== db) {
        const dd = db - da
        return (dd > 0 ? '+' : '−') + durUnit(Math.abs(dd), 'd')
    }
    return '≠'
}

export function adf_tipText(d, against) {
    if (d?.resized) return adf_resizedText(d.resized)
    if (d?.nested) {
        const head = against === 'next' ? t('Changed in the next version') : t('Changed since the previous version')
        return Array.isArray(d.paths) && d.paths.length ? head + ': ' + d.paths.join(', ') : head
    }
    const v = adf_valueText(adf_other(d, against))
    return against === 'next' ? t('Next version: {value}', { value: v }) : t('Previous version: {value}', { value: v })
}

export function adf_resizedText(rz) {
    const a = Array.isArray(rz) ? rz[0] : null, b = Array.isArray(rz) ? rz[1] : null
    if (a === null || a === undefined || b === null || b === undefined) return t('Rows cannot be matched, the whole table is marked')
    return t('Rows cannot be matched ({a} → {b} rows), the whole table is marked', { a, b })
}

// бейдж шапки: короткая подпись и полная строка; null — бейджа нет (флаг бэка выключен / нет данных)
export function adf_status(block, against = 'next') {
    if (!isObj(block)) return null
    const st = block.status
    const next = against === 'next'
    if (!st || st === 'off') return null
    if (st === 'ok' || st === 'live') {
        const n = adf_index(block, against).n
        const rz = Object.values(isObj(block.tables) ? block.tables : {}).map(resizedOf).find(Boolean)
        if (!n) return { label: '=', kind: 'none', text: next ? t('No changes against the next version') : t('No changes against the previous version') }
        const notes = []
        if (rz) notes.push(adf_resizedText(rz))
        if (block.truncated) notes.push(t('Too many changes: only the first ones are marked'))
        return { label: String(n), kind: 'ok', n,
            text: next ? tn(n, '{n} change against the next version', '{n} changes against the next version') : tn(n, '{n} change against the previous version', '{n} changes against the previous version'),
            note: notes.join('. ') }
    }
    if (st === 'deferred') return { label: '…', kind: 'pending', text: next ? t('Comparison with the next version is not calculated yet') : t('Comparison with the previous version is not calculated yet'), calc: true }
    if (st === 'calculating') return { label: '…', kind: 'pending', text: t('Calculating the comparison…') }
    if (st === 'first') return { label: '—', kind: 'first', text: t('First saved version - nothing to compare with') }
    if (st === 'last') return { label: '—', kind: 'first', text: t('Latest version - nothing newer to compare with') }
    if (st === 'deleted') return { label: '—', kind: 'first', text: block.reason ? String(block.reason) : t('This change deleted the record - there is no next version') }
    const reason = block.reason ? String(block.reason)
        : st === 'too_large' ? t('the record is too large to compare')
            : st === 'no_function' ? t('comparison is not installed in this database')
                : (st === 'prev_unavailable' || st === 'next_unavailable') ? t('the version body is not kept')
                    : st === 'this_unavailable' ? t('this version has no full body')
                        : st === 'denied' ? t('you have no access to compare these versions')
                            : st === 'segment_changed' ? t('the record moved to another segment between these versions')
                    : t('not provided by the server')
    return { label: '?', kind: 'unavailable',
        text: next ? t('Next version unavailable: {reason}', { reason }) : t('Previous version unavailable: {reason}', { reason }) }
}

// «Differences only»: строка формы / ТЧ прячется, если в ней нет изменений
export function adf_hides(view, changed) {
    return view === 'diff' && !changed
}

// строки AttrTabGrid (дерево: дети в .attrs) к скрытию в «Differences only»: лист — без изменения поля; группа — все дети скрыты
export function adf_tabRowsHidden(rows, idx, view, out = new Set()) {
    if (view !== 'diff' || !idx) return out
    const walk = (list) => {
        let anyShown = false
        for (const r of (Array.isArray(list) ? list : [])) {
            if (!r || typeof r !== 'object') continue
            const kids = Array.isArray(r.attrs) && r.attrs.length ? r.attrs : null
            let shown = !!idx.field(r.attr?.binding)
            if (kids) { const k = walk(kids); shown = shown || k }
            if (!shown) out.add(r)
            anyShown = anyShown || shown
        }
        return anyShown
    }
    walk(rows)
    return out
}

// строки ТЧ к скрытию в «Differences only»
export function adf_tableRowsHidden(rows, idx, tbl, view, out = new Set()) {
    if (view !== 'diff' || !idx || !idx.table(tbl)) return out
    ;(Array.isArray(rows) ? rows : []).forEach((r, i) => { if (r && typeof r === 'object' && !idx.rowState(tbl, i)) out.add(r) })
    return out
}

// ---- IE 2026 10 31 / ODOO-349799 (заказ Игоря: переход ‹ › к изменению на другой вкладке при первом открытии; скрытое поле) ----
// Путь по дереву attrs виджета (WIDGET.view: панели вкладок → вкладки → гриды → поля) до первого attr, подходящего под pred: [корень … attr]; нет — null
// opts.noDescend — типы attr, в детей которых не спускаемся (проба dev02 31.10: колонки ТЧ «Edges» и их фильтр — не поля формы, «order» уводил туда)
export function adf_attrPath(attrs, pred, opts = {}) {
    if (typeof pred !== 'function') return null
    const stop = opts && opts.noDescend instanceof Set ? opts.noDescend : null
    const walk = (list, path, depth) => {
        if (depth > 40) return null
        for (const a of (Array.isArray(list) ? list : [])) {
            if (!a || typeof a !== 'object') continue
            if (pred(a)) return [...path, a]
            if (stop && stop.has(a.attr_type)) continue
            if (Array.isArray(a.attrs) && a.attrs.length) { const r = walk(a.attrs, [...path, a], depth + 1); if (r) return r }
        }
        return null
    }
    return walk(attrs, [], 0)
}
const ADF_CONTAINERS = new Set(['AttrGrid', 'AttrTabGrid', 'AttrTab', 'AttrTabRow', 'AttrTabPanel'])
export const ADF_FIELD_NODESCEND = new Set(['AttrGrid'])   // поле формы ищется мимо колонок ТЧ
export const ADF_LANGS = ['uk', 'ru']
// attr поля формы по binding: не контейнер и не колонка ТЧ
export function adf_fieldPath(view, binding) {
    const w = String(binding || '')
    if (!w) return null
    return adf_attrPath(view, (a) => String(a.binding || '') === w && !ADF_CONTAINERS.has(a.attr_type), { noDescend: ADF_FIELD_NODESCEND })
}
// attr цели навигации в дереве view: поле — attr с binding цели (не контейнер), ячейка / строка / таблица — AttrGrid с binding ТЧ
export function adf_targetPath(view, target) {
    if (!target || typeof target !== 'object') return null
    const tableKind = target.kind === 'cell' || target.kind === 'row' || target.kind === 'table'
    if (tableKind) {
        const w = String(target.table || '')
        return w ? adf_attrPath(view, (a) => String(a.binding || '') === w && a.attr_type === 'AttrGrid') : null
    }
    return target.kind === 'field' ? adf_fieldPath(view, target.binding) : null
}
// перевод поля среди целей сравнения (проба dev02 31.10: title_uk / title_ru): 'title_uk' и 'meta.title_uk' → { base: 'title', lang: 'uk' },
// 'doc.tooltip_ru' → { base: 'doc.tooltip', lang: 'ru' }; langs — store.i18n_fieldLangs() (строки или { id }); без суффикса языка — null
export function adf_i18nOf(binding, langs = ADF_LANGS) {
    const b = String(binding || '')
    for (const L of (Array.isArray(langs) ? langs : [])) {
        const id = typeof L === 'string' ? L : (L && typeof L === 'object' ? String(L.id || L.code || '') : '')
        if (!id || id === 'en') continue
        if (b.length > id.length + 1 && b.endsWith('_' + id)) {
            let base = b.slice(0, -(id.length + 1))
            if (base === 'meta.title') base = 'title'
            return { base, lang: id }
        }
    }
    return null
}
// описание цели на форме: { path, i18n, kind } — kind: 'row' (строка грида формы AttrTabGrid), 'table' (ТЧ), 'standalone' (поле-компонент прямо во вкладке:
// AttrStrMulti «Comment»); i18n — цель-перевод поля, path ведёт к основному translate-полю. null — цели на форме нет (viewParams, order, служебные поля)
export function adf_targetInfo(view, target, langs = ADF_LANGS) {
    if (!target || typeof target !== 'object') return null
    if (target.kind === 'cell' || target.kind === 'row' || target.kind === 'table') {
        const path = adf_targetPath(view, target)
        return path ? { path, i18n: null, kind: 'table' } : null
    }
    if (target.kind !== 'field') return null
    let path = adf_fieldPath(view, target.binding), i18n = null
    if (!path) {
        const of = adf_i18nOf(target.binding, langs)
        if (!of) return null
        path = adf_fieldPath(view, of.base)
        if (!path || !path[path.length - 1].translate) return null
        i18n = of
    }
    return { path, i18n, kind: path.some(a => a.attr_type === 'AttrTabGrid') ? 'row' : 'standalone' }
}
// цели, до которых переход ‹ › дойдёт, и число остальных: счётчик «k / N» и строка «M of T changes are not shown on the form» в поповере.
// Формы без описания (view пуст) — как раньше: все цели, ищем по смонтированным гридам
export function adf_navTargets(view, targets, langs = ADF_LANGS) {
    const all = Array.isArray(targets) ? targets : []
    if (!Array.isArray(view) || !view.length) return { targets: all, hidden: 0, total: all.length }
    const out = all.filter(tg => !!adf_targetInfo(view, tg, langs))
    return { targets: out, hidden: all.length - out.length, total: all.length }
}
export function adf_notShownText(hidden, total) {
    return t('{n} of {total} changes are not shown on the form', { n: hidden, total })
}
// строки переводов «<поле> (uk)/(ru)» выключены опцией вида — переход встал на основное поле, подсказать опцию
export function adf_i18nHiddenText(field) {
    return t('Translation field {field}: enable «Show translation fields»', { field: String(field ?? '') })
}
// шаги по вкладкам-контейнерам на пути к цели (включая вложенные панели): { panel, tab, index } — index вкладки среди вкладок панели, как их раздаёт
// AttrTabPanel.tabAttrs (без pinnedHeader); вкладка-шапка (pinnedHeader) видна всегда — шага нет
export function adf_tabSteps(path) {
    const out = []
    for (let i = 0; i + 1 < (Array.isArray(path) ? path.length : 0); i++) {
        const panel = path[i], tab = path[i + 1]
        if (panel?.attr_type !== 'AttrTabPanel') continue   // проба dev02 31.10: AttrTab внутри AttrTabGrid — группа строк формы (SFTP), не вкладка: шага нет
        if (!tab || (tab.attr_type !== 'AttrTab' && tab.attr_type !== 'AttrTabRow') || !Array.isArray(panel?.attrs) || tab.pinnedHeader) continue
        const index = panel.attrs.filter(t => t && !t.pinnedHeader).indexOf(tab)
        if (index >= 0) out.push({ panel, tab, index })
    }
    return out
}
// уведомление «поле скрыто в этом виде» (колонка выключена настройкой вида / поле формы спрятано) — колонки и поля не включаем, только сообщаем
export function adf_hiddenText(field) {
    return t('Field {field} is hidden in this view', { field: String(field ?? '') })
}

// ТЧ с изменением (строки / ячейки / размер) в активной стороне сравнения — предварительная проверка вкладок (AttrTabPanel.tabsPrecheck) не прячет её вкладку,
// пока активно сравнение, даже если в этой версии ТЧ пуста (строки удалены / добавлены в другой версии); setting — store.setting (флаг fe.ux.auditRecordDiff)
export function adf_tableChanged(diff, binding, setting) {
    if (!isObj(diff) || !binding || !adf_on(setting)) return false
    const against = adf_againstOf(diff)
    const idx = adf_index(adf_block(diff, against), against)
    return !!(idx?.ok && idx.table(String(binding)))
}

// IE 2026 10 31 / ODOO-349799 (PR3, заказ Игоря «как в 1С»: клик по строке списка изменений позиционирует форму, клик по ячейке формы — строку списка).
// Вкладка «Changes» записи (BE compare_merge.tab): грид record._doc.compare_changes, строка несёт target бэка того же вида, что цели ‹ ›
// ({ kind: 'field', binding } | { kind: 'cell', table, row, col } | { kind: 'row', table, row } | { kind: 'table', table } | null — ячейки в этой записи нет).
// Выключатель fe.ux.compareMerge.linkRows (дефолт ВКЛ; false — прежнее поведение: строки и форма не связаны)
export const CM_FLAG = 'fe.ux.compareMerge.linkRows'
export const CM_ROWS_BINDING = '_doc.compare_changes'
export const CM_TAB_NAME = 'tab-compare'
export function cm_on(setting) { try { return setting(CM_FLAG, true) !== false } catch (e) { return true } }
// ключ цели для сопоставления строки «Changes» и ячейки формы; колонка ячейки — корень пути ('Номенклатура.title' → 'Номенклатура', как adf_index.cell)
export function adf_targetKey(target) {
    if (!target || typeof target !== 'object') return ''
    const k = target.kind
    if (k === 'field') return target.binding ? 'field:' + String(target.binding) : ''
    if (k === 'table') return target.table ? 'table:' + String(target.table) : ''
    if ((k === 'row' || k === 'cell') && target.table && Number.isInteger(Number(target.row))) {
        const head = String(target.table) + ':' + Number(target.row)
        return k === 'row' ? 'row:' + head : (target.col ? 'cell:' + head + ':' + String(target.col).split('.')[0] : '')
    }
    return ''
}
// позиция цели в списке ‹ › (adf_nav.targets): точное совпадение ключа; поле-объект формы ('doc.params', изменились вложенные) — первая цель под ним;
// строка ТЧ без колонки — первая ячейка этой строки. -1 — нет
export function adf_targetIndex(targets, target) {
    const list = Array.isArray(targets) ? targets : []
    const key = adf_targetKey(target)
    if (!key) return -1
    const i = list.findIndex(tg => adf_targetKey(tg) === key)
    if (i >= 0) return i
    if (target.kind === 'field') return list.findIndex(tg => tg?.kind === 'field' && String(tg.binding || '').startsWith(String(target.binding) + '.'))
    if (target.kind === 'row') return list.findIndex(tg => tg?.kind === 'cell' && adf_targetKey(tg).startsWith('cell:' + key.slice(4) + ':'))
    return -1
}
// цель строки «Changes»: объект бэка или его JSON-строка (грид мог привести колонку к тексту)
export function cm_rowTarget(row) {
    const tg = row && typeof row === 'object' ? row.target : null
    if (tg && typeof tg === 'object') return tg
    if (typeof tg === 'string' && tg.startsWith('{')) { try { const o = JSON.parse(tg); return o && typeof o === 'object' ? o : null } catch (e) { return null } }
    return null
}
// цель выделенной ячейки формы по контексту разницы грида (AttrGrid.auditDiff_ctx: tabGrid / table / idx / rowIdx): null — ячейка без изменения
export function cm_targetOf(ctx, dataItem, colBinding) {
    if (!ctx?.idx || !dataItem || typeof dataItem !== 'object') return null
    if (ctx.tabGrid) {
        const b = dataItem.attr?.binding
        return (b && ctx.idx.field(b)) ? { kind: 'field', binding: String(b) } : null
    }
    const i = ctx.rowIdx?.get(dataItem)
    if (i === undefined || !ctx.table) return null
    const st = ctx.idx.rowState(ctx.table, i)
    if (!st) return null
    if (st === 'resized') return { kind: 'table', table: ctx.table }
    const col = String(colBinding || '').split('.')[0]
    if (col && ctx.idx.cell(ctx.table, i, col)) return { kind: 'cell', table: ctx.table, row: i, col }
    return { kind: 'row', table: ctx.table, row: i }
}
// смена выделения пришла от указателя (клик / тап), не от клавиш: стрелки по списку «Changes» не должны уводить на вкладку поля
export function cm_pointerEvt(e) { return !!e && /^(pointer|mouse|click|dblclick|touch)/.test(String(e.type || '')) }
